import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const steps = [
  { num: '1', titleKey: 'step_1_title', descKey: 'step_1_desc', icon: 'ri-edit-line' },
  { num: '2', titleKey: 'step_2_title', descKey: 'step_2_desc', icon: 'ri-user-search-line' },
  { num: '3', titleKey: 'step_3_title', descKey: 'step_3_desc', icon: 'ri-phone-line' },
  { num: '4', titleKey: 'step_4_title', descKey: 'step_4_desc', icon: 'ri-checkbox-circle-line' },
];

export default function Equipe() {
  const { t } = useTranslation('apropos');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="comment-ca-marche" className="bg-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('equipe_h2')}
          </h2>
          <p className="text-slate-primary/60 text-sm md:text-base mt-3 max-w-2xl mx-auto">
            {t('equipe_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {steps.map((step, idx) => (
            <div
              key={idx}
              className={`bg-soft-gray rounded-xl p-6 md:p-8 text-center transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 150 + 200}ms` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-copper mx-auto mb-5">
                <span className="text-white font-manrope font-bold text-lg">{step.num}</span>
              </div>
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-copper/10 mx-auto mb-4">
                <i className={`${step.icon} text-copper text-xl`} />
              </div>
              <h3 className="font-manrope font-bold text-slate-primary text-sm md:text-base tracking-wide mb-3">
                {t(step.titleKey)}
              </h3>
              <p className="text-slate-primary/50 text-sm leading-relaxed">{t(step.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}